window.ipinfusion = window.ipinfusion || {};
/**
 * Popup functionality using magnific-popup (jquery);
 */
if ('undefined' != typeof jQuery) jQuery(function($){
    ipinfusion.setupPopups = function(){
        if ( 'undefined' == typeof $.magnificPopup) return;
        // find all inline popups
        $('.popup').each(function(){
            // it is recommended that .mfp-hide always be added manually
            // however, add .mfp-hide class if not present (e.g. forgotten)
            $(this).addClass('mfp-hide');
            // add .popup-inline to links if not present
            if (this.id) $('[href="#'+ this.id +'"]').addClass('popup-inline');
        });
        // default inline popup
        $('.popup-inline').magnificPopup({
            type: 'inline',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            midClick: true,
            callbacks: {
                close: function() {
                    // find all popups with video tag and pause on close
                    var popupContents = document.querySelectorAll('.popup');
                    if (popupContents) popupContents.forEach(function(elem) {
                        var vid = elem.querySelector('video');
                        if (vid) vid.pause();
                    });
                }
            }
        });
        // video popup
        $('.popup-video').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade popup-video',
            removalDelay: 160,
            midClick: true
        });
        // iframe popup
        $('.popup-iframe').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            midClick: true
        });
        // image popup
        $('.popup-image').magnificPopup({
            type: 'image',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            midClick: true
        });
        // gallery popup (for images)
        // create separate galleries using .popup-gallery--group-[n]
        // I recommend NOT adding an image to multiple gallery groups, while this will work, the behavior can be confusing
        // example: .popup-gallery, .popup-gallery--group-1, .popup-gallery--group-[n]
        for( var i = 0; i < 10; i++ ) {
            var elems = $('.popup-gallery' + (i ? '--group-' + i : ''));
            if (!elems.length) continue;
            elems.magnificPopup({
                type: 'image',
                mainClass: 'mfp-fade',
                removalDelay: 160,
                gallery: {
                    enabled: true
                }
            });
        }
    }
    ipinfusion.setupPopups();
});
